import { Component } from '@angular/core';


@Component({
  selector: '.app-country.container-xxl.flex-grow-1.p-0',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.css']
})
export class CountryComponent {

}
